import _typeof from "@babel/runtime/helpers/esm/typeof";
var _my$getSystemInfoSync;
import report from "./report";
import * as _config from "./config";
export { _config as config };
export * from "./cookie";
export * from "./dom";
export * from "./event";
export * from "./formatData";
export { getEnv } from "./getEnv";
export * from "./getSystemInfo";
export * from "./helper";
export * from "./storage";
export { default as _storage } from "./temporary_storage";
export * from "./tools";
export { default as url } from "./url";
export var isAppx = (typeof my === "undefined" ? "undefined" : _typeof(my)) === 'object';
var platform = (isAppx && ((_my$getSystemInfoSync = my.getSystemInfoSync()) === null || _my$getSystemInfoSync === void 0 ? void 0 : _my$getSystemInfoSync.platform)) + '';
export var isIos = isAppx ? /ios|iphone\s+os/i.test(platform) : /iphone|ipad|ipod/gi.test(navigator.userAgent);
export var isAndroid = isAppx ? /android/i.test(platform) : /android/i.test(navigator.userAgent);
export function getUuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}
export function isObject(value) {
  var toString = Object.prototype.toString;
  return value !== null && toString.call(value) === '[object Object]';
}
export function queryParse(url) {
  var qs = {};
  try {
    if (!url) {
      var _window, _window$location;
      // eslint-disable-next-line no-param-reassign
      url = (_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.href;
    }
    url.replace(/([^?=&#]+)(=([^&#]*))?/g, function (_$0, $1, _$2, $3) {
      if ($3 === undefined) {
        return '';
      }
      qs[$1] = decodeURIComponent($3);
      return qs[$1];
    });
    return qs;
  } catch (error) {
    report({
      logType: 'error',
      title: 'query parse error',
      msg: error
    });
    return {};
  }
}
export function addEvent(evnt, ele, func) {
  var _window2;
  var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  if (!evnt) {
    return;
  }
  var elem = ele || ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.document);
  if (elem.addEventListener) {
    // W3C DOM
    elem.addEventListener(evnt, func, capture);
  } else if (elem.attachEvent) {
    // IE DOM
    elem.attachEvent("on".concat(evnt), func);
  } else {
    elem[evnt] = func;
  }
}
export function getValueFromSearch(name, val) {
  var result = '';
  try {
    var pattern = new RegExp("(?=\\?|\\&|\\b|^)".concat(name, "\\=(.+?)(?=\\&|$)"));
    result = pattern.exec(val);
    result = result ? "".concat(result[1]) : '';
    result = decodeURIComponent(result);
  } catch (ex) {
    console.warn(ex);
  }
  return result;
}

// 获取url上的参数，如果获取不到，从启动参数获取
export function getValue(name) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : location.search;
  if (!name) {
    return '';
  }
  var result = '';
  result = getValueFromSearch(name, val);
  return result;
}